/**
 * Finds the path from root to the matching menu item in a tree structure.
 * Used by menu components to determine which items to highlight/expand.
 *
 * @param url - The URL to match against menu items
 * @param source - Array of menu items (tree structure with children)
 * @param options - Optional configuration for property names and partial matching
 * @returns Array of menu items from root to matched item, or false if not found
 */
export function findMenuPath(
  url: string,
  source: any[],
  options: { keyProperty?: string; childrenProperty?: string; partialMatch?: boolean } = {},
  path: any[] = []
): any {
  const { keyProperty = 'url', childrenProperty = 'children', partialMatch = false } = options;
  let found: any = false;
  return (
    source?.some((entry: any) => {
      const entryKey = entry?.[keyProperty];
      const isMatch = partialMatch
        ? entryKey === url || entryKey === url.slice(0, url.lastIndexOf('/'))
        : entryKey === url;
      if (isMatch) {
        path.push(entry);
        return true;
      } else {
        return (found = findMenuPath(url, entry?.[childrenProperty], options, path.concat(entry)));
      }
    }) &&
    (found || path)
  );
}

/**
 * Activates menu items based on the current URL.
 * Deep-clones menuData, marks the matching item as selected, and opens parent items.
 */
export function activateMenuByUrl(url: string, menuData: any[], partialMatch = false): any[] {
  if (!menuData) {
    return menuData;
  }
  const cloned = structuredClone(menuData);
  const pathWithSelection = findMenuPath(url, cloned, { partialMatch });
  if (pathWithSelection) {
    pathWithSelection.pop().selected = true;
    pathWithSelection.forEach((parent: any) => (parent.open = true));
  }
  return cloned;
}
